import React from "react";
import PropTypes from "prop-types";

export const MainOption = props => {
  /*** option name format - 1. OptionName ***/
  const optionName = `${props.index + 1}. ${props.optionName}`,
    styleForLi = {
      justifyContent: props.justifyContent,
      alignContent: props.alignContent,
      gridTemplateColumns: props.gridTemplateColumns
    },
    styleForInput = {
      width: props.inputWidth,
      height: props.inputHeight
    };
  return (
    <li className="main-option-option-step-1" style={styleForLi}>
      <label className="main-options-option-name-step-1">{optionName}</label>
      <div className="wrapper-option-value-step-1">
        <input
          type={props.type}
          className="main-options-input-step-1"
          data-input-name={props.dataInputName}
          value={props.value}
          min={0}
          step={props.step}
          style={styleForInput}
          data-input-number={props.dataInputNumber}
          data-input-lid={props.dataInputLid}
          onChange={props.changeInputValue}
        />
      </div>
    </li>
  );
};

MainOption.defaultProps = {
  justifyContent: "start",
  alignContent: "top",
  gridTemplateColumns:
    "calc( (100vw - 375px)/(1920 - 375) * (200 - 110) + 110px) auto",
  inputWidth: "calc( (100vw - 375px)/(1920 - 375) * (137 - 41) + 51px)",
  inputHeight: "calc( (100vw - 375px)/(1920 - 375) * (44 - 23) + 18px)",
  step: 20
};

MainOption.propTypes = {
  type: PropTypes.string,
  justifyContent: PropTypes.string,
  alignContent: PropTypes.string,
  step: PropTypes.number,
  gridTemplateColumns: PropTypes.string,
  inputWidth: PropTypes.string,
  inputHeight: PropTypes.string,
  dataInputName: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dataInputNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataInputLid: PropTypes.bool,
  changeInputValue: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/buildcomponent/Options/MainOption.js